var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 15.75h-1.5v-1.5A2.252 2.252 0 019 12h4.5v1.5H9a.75.75 0 00-.75.75v1.5zM11.25 11.25a3 3 0 110-6 3 3 0 010 6zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM18 16.5a3 3 0 110-6 3 3 0 010 6zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM22.5 21H21v-1.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 00-.75.75V21h-1.5v-1.5a2.252 2.252 0 012.25-2.25h4.5a2.252 2.252 0 012.25 2.25V21z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.8l-3.926-2.093A6.74 6.74 0 013 12.75V3h15v4.5h1.5V3A1.502 1.502 0 0018 1.5H3A1.502 1.502 0 001.5 3v9.75a8.236 8.236 0 004.368 7.28L10.5 22.5v-1.7z",
    fill: "#ED1B2E"
  })));
}

export default SvgIconBusiness;